"use client";

import { useEffect } from "react";

import { Button } from "@tripcart/traveler-ui/components/button";

import { useTranslator } from "@/lib/translation-context";

import styles from "./root-error-surface.module.css";

export default function RootErrorSurface({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslator();

  useEffect(() => {
    // Literal process.env.NODE_ENV (Next inlines it) avoids importing
    // @/env.client, which pulls all of zod into this client chunk.
    // eslint-disable-next-line no-restricted-properties -- the suggested fix (import the validated env) is exactly the zod pull we're avoiding
    if (process.env.NODE_ENV !== "production") {
      console.error(error);
    }
  }, [error]);

  return (
    <div className={styles.surface}>
      <h1 className={styles.title}>{t("Something Went Wrong")}</h1>
      <p className={styles.body}>
        {t(
          "We ran into an unexpected error. Please try again — if the problem persists, contact support.",
        )}
      </p>
      <Button size="lg" onClick={reset}>
        {t("Try Again")}
      </Button>
    </div>
  );
}
